import ClubOfferingSettings from '../dto/offering/ClubOfferingSettings.js';
import Error from '../model/Error.js';
import axios from 'axios';

export default class ClubOfferingSettingsRepository {

    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/settings`)
                .then(response => resolve(ClubOfferingSettings.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubId, clubOfferingSettings) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/offerings/settings`, clubOfferingSettings.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
